export function getUsStates() {
    const usStates = [
        {
            name: 'Alabama',
            code: 'AL',
        },
        {
            name: 'Alaska',
            code: 'AK',
        },
        {
            name: 'American Samoa',
            code: 'AS',
        },
        {
            name: 'Arizona',
            code: 'AZ',
        },
        {
            name: 'Arkansas',
            code: 'AR',
        },
        {
            name: 'California',
            code: 'CA',
        },
        {
            name: 'Colorado',
            code: 'CO',
        },
        {
            name: 'Connecticut',
            code: 'CT',
        },
        {
            name: 'Delaware',
            code: 'DE',
        },
        {
            name: 'District Of Columbia',
            code: 'DC',
        },
        {
            name: 'Federated States Of Micronesia',
            code: 'FM',
        },
        {
            name: 'Florida',
            code: 'FL',
        },
        {
            name: 'Georgia',
            code: 'GA',
        },
        {
            name: 'Guam',
            code: 'GU',
        },
        {
            name: 'Hawaii',
            code: 'HI',
        },
        {
            name: 'Idaho',
            code: 'ID',
        },
        {
            name: 'Illinois',
            code: 'IL',
        },
        {
            name: 'Indiana',
            code: 'IN',
        },
        {
            name: 'Iowa',
            code: 'IA',
        },
        {
            name: 'Kansas',
            code: 'KS',
        },
        {
            name: 'Kentucky',
            code: 'KY',
        },
        {
            name: 'Louisiana',
            code: 'LA',
        },
        {
            name: 'Maine',
            code: 'ME',
        },
        {
            name: 'Marshall Islands',
            code: 'MH',
        },
        {
            name: 'Maryland',
            code: 'MD',
        },
        {
            name: 'Massachusetts',
            code: 'MA',
        },
        {
            name: 'Michigan',
            code: 'MI',
        },
        {
            name: 'Minnesota',
            code: 'MN',
        },
        {
            name: 'Mississippi',
            code: 'MS',
        },
        {
            name: 'Missouri',
            code: 'MO',
        },
        {
            name: 'Montana',
            code: 'MT',
        },
        {
            name: 'Nebraska',
            code: 'NE',
        },
        {
            name: 'Nevada',
            code: 'NV',
        },
        {
            name: 'New Hampshire',
            code: 'NH',
        },
        {
            name: 'New Jersey',
            code: 'NJ',
        },
        {
            name: 'New Mexico',
            code: 'NM',
        },
        {
            name: 'New York',
            code: 'NY',
        },
        {
            name: 'North Carolina',
            code: 'NC',
        },
        {
            name: 'North Dakota',
            code: 'ND',
        },
        {
            name: 'Northern Mariana Islands',
            code: 'MP',
        },
        {
            name: 'Ohio',
            code: 'OH',
        },
        {
            name: 'Oklahoma',
            code: 'OK',
        },
        {
            name: 'Oregon',
            code: 'OR',
        },
        {
            name: 'Palau',
            code: 'PW',
        },
        {
            name: 'Pennsylvania',
            code: 'PA',
        },
        {
            name: 'Puerto Rico',
            code: 'PR',
        },
        {
            name: 'Rhode Island',
            code: 'RI',
        },
        {
            name: 'South Carolina',
            code: 'SC',
        },
        {
            name: 'South Dakota',
            code: 'SD',
        },
        {
            name: 'Tennessee',
            code: 'TN',
        },
        {
            name: 'Texas',
            code: 'TX',
        },
        {
            name: 'Utah',
            code: 'UT',
        },
        {
            name: 'Vermont',
            code: 'VT',
        },
        {
            name: 'Virgin Islands',
            code: 'VI',
        },
        {
            name: 'Virginia',
            code: 'VA',
        },
        {
            name: 'Washington',
            code: 'WA',
        },
        {
            name: 'West Virginia',
            code: 'WV',
        },
        {
            name: 'Wisconsin',
            code: 'WI',
        },
        {
            name: 'Wyoming',
            code: 'WY',
        },
    ];
    return usStates;
}

/*
 * for AA/AE/AP States
 */
export function getAfStates() {
    const afStates = [
        {
            name: 'AA  (Armed forces Americas)',
            code: 'AA',
        },
        {
            name: 'AE (Armed forces Europe)',
            code: 'AE',
        },
        {
            name: 'AP (Armed forces Pacific)',
            code: 'AP',
        },
    ];
    return afStates;
}

/*
 * for APO/FPO/DPO States
 */
export function getMilitaryAddressType() {
    const militaryAddressType = [
        {
            name: 'APO',
            code: 'APO',
        },
        {
            name: 'FPO',
            code: 'FPO',
        },
        {
            name: 'DPO',
            code: 'DPO',
        },
    ];
    return militaryAddressType;
}
export function getCanadaStates() {
    const canadaStates = [
        { code: 'AB', name: 'Alberta' },
        { code: 'BC', name: 'British Columbia' },
        { code: 'MB', name: 'Manitoba' },
        { code: 'NB', name: 'New Brunswick' },
        { code: 'NL', name: 'Newfoundland And Labrador' },
        { code: 'NT', name: 'Northwest Territories' },
        { code: 'NS', name: 'Nova Scotia' },
        { code: 'NU', name: 'Nunavut' },
        { code: 'ON', name: 'Ontario' },
        { code: 'PE', name: 'Prince Edward Island' },
        { code: 'QC', name: 'Quebec' },
        { code: 'SK', name: 'Saskatchewan' },
        { code: 'YT', name: 'Yukon' },
    ];
    return canadaStates;
}
